import React from 'react';

// How many records the current filters match, shown next to the filter controls
// on the /manage list pages. Server-paginated pages pass the API's `total` (not
// the current page's row count); client-filtered pages pass the filtered length.
// While a load is in flight the previous number stays put — only the very first
// load shows the placeholder, so the number never flickers on every keystroke.
const ResultCount = ({ count, noun = 'record', plural, loading = false, className = '' }) => {
  const n = Number(count) || 0;
  const label = n === 1 ? noun : (plural || `${noun}s`);
  return (
    <span className={`text-sm text-slate-500 whitespace-nowrap ${className}`}>
      {loading && !count ? '…' : `${n.toLocaleString()} ${label}`}
    </span>
  );
};

export default ResultCount;
